export const ApiRoutes = {

    API_BASE_URL: "https://api.touch-reality.com",
    GROUP_BASE_PATH: 'group', 
    USERS: {
        endpoint: `/users`,
    },
    STORES: {
        endpoint: (groupStoreId: string) => `/${ApiRoutes.GROUP_BASE_PATH}/${groupStoreId}/stores`,
    },
    CUSTOMERS: {
        endpoint: (groupStoreId: string) => `/${ApiRoutes.GROUP_BASE_PATH}/${groupStoreId}/customers`,
    },
    PROJECTS: {
        endpoint: (groupStoreId: string) => `/${ApiRoutes.GROUP_BASE_PATH}/${groupStoreId}/projects`,
        DRAFTS: {
            endpoint: (groupStoreId: string, projectId: string) => `/${ApiRoutes.GROUP_BASE_PATH}/${groupStoreId}/projects/${projectId}/draft`,
        },
    },
    DOCUMENTS: {
        endpoint: (groupStoreId: string, projectId: string) => `/${ApiRoutes.GROUP_BASE_PATH}/${groupStoreId}/projects/${projectId}/documents`,
    },
    DELIVERIES: {
        endpoint: (groupStoreId: string) => `/${ApiRoutes.GROUP_BASE_PATH}/${groupStoreId}/deliveries`,
    },
    SEARCHES: {
        endpoint: (groupStoreId: string) => `/${ApiRoutes.GROUP_BASE_PATH}/${groupStoreId}/search`,
    },
    MAP: {
        endpoint: () => `${ApiRoutes.API_BASE_URL}/maps`,
    },
    HUB: {
        endpoint: () => `${ApiRoutes.API_BASE_URL}/hub`,
    },
}